import styles from "./Users.module.css";

export type NormalizeStatus = "pending" | "loading" | "success" | "failed";

export function StatusBadge({ status }: { status: NormalizeStatus }) {
  if (status === "pending") return null;

  const classMap: Record<string, string> = {
    loading: styles.statusPending,
    success: styles.statusSuccess,
    failed: styles.statusFailed,
  };

  const labelMap: Record<string, string> = {
    loading: "NORMALIZING",
    success: "DONE",
    failed: "FAILED",
  };

  return (
    <span className={`${styles.statusBadge} ${classMap[status] || ""}`}>
      {labelMap[status] || status.toUpperCase()}
    </span>
  );
}

export function isValidFirmRef(firmRef: string | null | undefined): boolean {
  if (!firmRef) return false;
  const num = Number(firmRef);
  return Number.isInteger(num) && num > 0;
}
